const riot = require('riot');

riot.tag2('module-table-accordion', '<div class="relative w-full transition" ref="body" riot-style="max-height: {isClose ? 53 : refs.body.scrollHeight}px;"> <table class="w-full border-spacing-0 border-collapse-collapse"> <thead> <tr class="relative h52 bg-background_primary border-bottom cursor-pointer" onclick="{onToggleOpen}"> <th class="min-width-210 pl24 text-left text-label_high">{opts.section.label}</th> <th class="min-width-772" colspan="3"></th> <th class="w10per min-width-175 pl24 pr16 text-right text-label_high">{opts.section.hours}時間</th> <th class="w20 pr24"> <div class="f fh s24 circle hover-trigger hover-bg-separator_opaque transition {isClose ? &quot;rotate-0&quot; : &quot;rotate-180&quot;}"><i class="icon-arrow_down fs16"></i></div> </th> </tr> </thead> <tbody class="bg-white"> <tr class="h60 border-bottom cursor-pointer hover-trigger hover-bg-label_pale transition" each="{item in opts.section.items}" onclick="{onOpenModalRecord}" index="{index}"> <td class="pl24 text-left"> <div class="f fm" if="{item.relation.project &amp;&amp; item.relation.project.doc.exists}"> <div class="flex-fixed s8 circle mr4" riot-style="background-color: {item.getColor()}"></div> <div class="fs12 line-clamp-1 word-break-all" riot-style="color: {item.getColor()}">{item.relation.project.data.name}</div> </div> </td> <td class="w200 pl24 text-left"> <div class="f fm"> <div class="fs12 text-label_high line-clamp-1 word-break-all">{item.relation.created_user.data.display_name}</div> </div> </td> <td class="pl24 text-left"> <div class="f fm"> <div class="fs12 text-label_high word-break-all line-clamp-1">{item.data.title}</div> </div> </td> <td class="w200 pl24 text-left"> <div class="w200 white-space-nowrap overflow-x-scroll scrollbar-none"> <div class="mr4 mr0-last" data-is="atom-tag" each="{tag in item.data.tags}" label="{tag}"></div> </div> </td> <td class="pl24 pr16 text-right fs12 text-label_high white-space-nowrap"><span class="mr5">{dayjs(item.data.start_at).format(\'HH:mm\')} - {dayjs(item.data.end_at).format(\'HH:mm\')}</span><span>({(item.getDuration()/1000/60/60).toLocaleString(undefined, {maximumFractionDigits: 2})}h)</span></td> <td class="pr24"></td> </tr> </tbody> </table> </div>', 'module-table-accordion,[data-is="module-table-accordion"]{display:block}', '', function(opts) {
    this.isClose = false;

    this.onToggleOpen = (e) => {
      this.isClose = !this.isClose;
      this.update();
    };

    this.onOpenModalRecord = (e) => {
      var record = e.item.item;

      if (!record.isMine()) {
        spat.modal.alert('自分のレコードではないので編集できません');
        return;
      }
      var item = {
        record: record,
        start_at: record.data.start_at,
        end_at: record.data.end_at,
      };

      var modal = spat.modal.open('modal-record-edit', {
        item: item,
      });

      modal.on('submit', async ({ data }) => {
        await record.update({
          title: data.title,
          project_ref: data.project ? data.project.ref : null,
          description: data.description || '',
          tags: data.tags,
          updated_at: Date.now(),
          start_at: data.start_at,
          end_at: data.end_at,
        });
        await record.refresh();
        record = await record.fetch({ relation: true });
        this.update();

      });

      modal.on('delete', async () => {
        var result = await spat.modal.confirm('削除しますか？');
        if (!result) return;
        app.store.doc(record.path).delete();

        this.parent.trigger('changerecord');
        this.trigger('changerecord');
      });
    };
});